// Takes Tag data from server and stores it in object with helper methods for accessing it.

class Tag {
  constructor(tagData) {
    Object.assign(this, tagData);
  }
}

export default Tag;
